// import { faSpinner } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import React, { useEffect, useState } from 'react'
// import Patient from '../../../../../libs/api/services/Patient'

import { useEffect, useRef, useState } from "react";
import Authentication from "../../../../../libs/api/services/Authentication";
import Patient from "../../../../../libs/api/services/Patient";
import WorkFlowQuickTasks from "../../../workflow/components/widgets/WorkFlowQuickTasks";
import PatientProfileContainer from "./PatientProfileContainer";
import PatientProfileResponsive from "./PatientProfileResponsive";
import PatientProfileSideBar from "./PatientProfileSideBar";

// import PatientManagementDetailsComponent from '../PatientManagementDetailsComponent'
export default function PatientProfileDetailsContainer({ id, mode, profile, setProfile, patientUserID }) {
    const [category, setCategory] = useState([])
    const [permissions, setPermissions] = useState([])
    const loadedProfileIdRef = useRef()

    useEffect(() => {
        let mounted = true
        const _load = async () => {
            const roles = await Patient.ListUserAccessRolesByRole(Authentication.getFacilityRole()).catch(() => [])
            if (mounted) setPermissions(roles || [])
        }
        _load()
        return () => {
            mounted = false
        }
    }, [])

    useEffect(() => {
        let mounted = true
        const _loadProfile = async () => {
            if (!profile || !profile.id) return
            if (profile.id === '00000000-0000-0000-0000-000000000000') return
            if (loadedProfileIdRef.current === profile.id) return

            const hasLoadedDetails = Array.isArray(profile.profiles) && profile.profiles.length > 0
            if (hasLoadedDetails) {
                loadedProfileIdRef.current = profile.id
                return
            }

            const _profile = await Patient.LoadPatient(profile.id).catch(() => undefined)
            if (!_profile) return
            if (mounted) {
                loadedProfileIdRef.current = profile.id
                setProfile(_profile)
            }
        }

        _loadProfile()
        return () => {
            mounted = false
        }
    }, [profile, setProfile])


    // alert(profile.userProfile.id)
    return (<div className='d-flex flex-grow-1 flex-column flex-xl-row mh-100' style={{ overflow: 'auto' }}>

        <PatientProfileSideBar
            profile={profile}
            isOwn={profile && profile.userProfile && profile.userProfile.id === parseInt(Authentication.UserId())}
            setProfile={setProfile}
            setCategory={setCategory}
            category={category}
            setPermissions={setPermissions}
        />
        <PatientProfileResponsive
            profile={profile}
            setProfile={setProfile}
            isOwn={profile && profile.userProfile && profile.userProfile.id === parseInt(Authentication.UserId())} />
        <div className="flex-grow-1 d-flex flex-column ">
            <div className='d-flex flex-column flex-grow-1' style={{ overflow: 'auto' }}>
                {category && category.id && <PatientProfileContainer permissions={permissions}
                    // saving={loading} 
                    isOwn={profile && profile.userProfile && profile.userProfile.id === parseInt(Authentication.UserId())}
                    category={category}
                    profile={profile}
                    setProfile={setProfile}
                // onSetValue={(i, v) => _handleSetValue(i, v)} onSave={_handleSave} 
                />}
            </div>
            {
                patientUserID
                    ?
                    <></>
                    :
                    !mode &&
                    <WorkFlowQuickTasks
                        key={'WorkFlowQuickTasks:Patient Profile Events'}
                        group='Patient Profile Events'
                        patientId={id}
                        category={category}
                        filters={[
                            {
                                type: 'category',
                                value: category
                            }
                        ]}
                    />
            }
        </div>
    </div>)
}
// export default function PatientProfileDetailsContainer({ category, onSave, profile, onSetValue, saving, permissions }) {
//     const [loading, setLoading] = useState(false)
//     const [layout, setLayout] = useState([])
//     useEffect(() => { if (category.id !== -1) _loadFields() }, [category])

//     const _loadFields = () => {
//         setLoading(true)
//         Patient.LoadFields(category.id)
//             .then((r) => {
//                 _renderComonents(r)
//             })
//     }

//     const _handleSetValue = (i, v) => {
//         onSetValue(i, v)
//     }

//     var row_cntr = 0;
//     const _handleLayoutSize = async (_id, options) => {
//         const _layout = options.find(f => f.category === 'Layout')
//         if (typeof _layout !== 'undefined') {
//             const _grid = _layout.options.find(f => f.option === 'Grid')
//             if (typeof _grid !== 'undefined') {
//                 const r = await Patient
//                     .FieldTypesOptionsDefaults(_id, _grid.id)
//                 if (r && r.length > 0) {
//                     if (r[0].value && r[0].value.length > 0) {
//                         var cols = JSON.parse(r[0].value[0].property)
//                         row_cntr += cols.lg;
//                         if (row_cntr > 12)
//                             row_cntr = 0;
//                         return 'col-lg-' + cols.lg + ' col-md-' + cols.md + ' col-sm-' + cols.sm + ' '
//                     }
//                 }
//                 else {
//                     row_cntr = 0
//                 }
//             } else {
//                 row_cntr = 0
//             }
//         } else {
//             row_cntr = 0
//         }
//         return 'col-lg-12 col-md-12 col-sm-12 '
//     }
//     const _renderComonents = async (fields) => {
//         var ret_r = []
//         var ret_c = []
//         if (fields) {
//             for (var i = 0; i < Object.keys(fields).length; i++) {
//                 //permissions
//                 // console.log(fields[i])
//                 var _permission = permissions.find(a => a.field.id == fields[i].id)
//                 var _can_edit = permissions.find(a => a.field.id == fields[i].id && a.accessType === 'Edit')
//                 if (!_permission) continue;

//                 const lo = await _handleLayoutSize(fields[i].id, fields[i].type.patientProfileDetailTypeOptions)
//                 if (row_cntr === 0) {
//                     ret_r.push(<div className='row'>{ret_c}</div>)
//                     ret_c = []
//                 }
//                 ret_c.push(
//                     <div key={fields[i].id} className={lo}>
//                         {
//                             <PatientManagementDetailsComponent
//                                 id={fields[i].id}
//                                 canEdit={_can_edit}
//                                 value={fields[i].value}
//                                 type={fields[i].type.type}
//                                 options={fields[i].type.patientProfileDetailTypeOptions}
//                                 profile={profile}
//                                 onChanged={(prop, val) => _handleSetValue(prop, val)}
//                             />
//                         }

//                     </div>
//                 )
//             }
//             ret_r.push(<div className='row'>{ret_c}</div>)
//         }
//         setLoading(false)
//         setLayout(ret_r);
//     }

//     if (loading) return <div className='h-100 w-100 d-flex align-items-center justify-content-center'><div><FontAwesomeIcon icon={faSpinner} spin /> Loading Patient Details</div></div>
//     return (
//         <>
//             <div className='flex-grow-1 p-2' style={{ overflow: 'auto' }}>
//                 {layout.map((l) => l)}
//             </div>
//             <div className='flex-shrink-1 justify-content-center d-flex align-items-center px-2'>
//                 {
//                     saving
//                         ?
//                         <div className='m-3'><b><FontAwesomeIcon icon={faSpinner} spin /></b></div>
//                         :
//                         category.id !== -1 ?
//                             <button
//                                 //  className={'btn bg-primary-btn m-3 '.concat(changes.length > 0 ? '' : ' disabled ')}
//                                 className={'btn bg-primary-btn m-3 '}
//                                 onClick={(e) => onSave()}
//                             >Save Changes</button> : <></>
//                 }
//             </div>
//         </>
//     )
// }
